import type { StreamStatus } from "..";
import { GameLaunchStatus } from "../constants/webrtc";

export const shouldSimulateMouseEvents = (
  streamStatus?: StreamStatus,
): boolean => {
  if (!streamStatus?.status) return false;
  const statusValues = Object.values(GameLaunchStatus);
  const currentIndex = statusValues.indexOf(streamStatus.status);
  const launchingIndex = statusValues.indexOf(
    GameLaunchStatus.STATUS_GAMERUNNING,
  );
  return currentIndex !== -1 && currentIndex < launchingIndex;
};
